import {isEmpty, map} from 'lodash';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Icon, Table, TableBody, TableCell, TableRow} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {IpInfo} from 'types';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.SETTINGS.IP_WHITELIST;

type Props = {
    ipInfos: IpInfo[];
    renderCreatedBy: (eid: number) => React.ReactElement;
    renderCreatedAt: (date: Date) => string;
    className?: string;
    onDelete: (index: number) => void;
}

export const IpTable: React.FC<Props> = ({ipInfos, renderCreatedBy, renderCreatedAt, className, onDelete}) => {
    const {t} = useTranslation();
    const headers = useMemo(() => [
        {children: t(T_KEYS.HEADERS.IP), className: 'tw-w-64'},
        {children: t(T_KEYS.HEADERS.CREATED_BY)},
        {children: t(T_KEYS.HEADERS.CREATED_AT)},
        {children: t(T_KEYS.HEADERS.DESCRIPTION)},
        {children: t(T_KEYS.HEADERS.ACTIONS), className: 'tw-w-24'}
    ], [t]);

    return (
        <Table headers={headers} noData={isEmpty(ipInfos)} className={className}>
            <TableBody>
                {map(ipInfos, (ipInfo, index) => (
                    <TableRow key={ipInfo.id || ipInfo.ip}>
                        <TableCell>{ipInfo.ip}</TableCell>
                        <TableCell>{renderCreatedBy(ipInfo.createdBy)}</TableCell>
                        <TableCell>{renderCreatedAt(ipInfo.createdAt)}</TableCell>
                        <TableCell>{ipInfo.description}</TableCell>
                        <TableCell className='tw-w-24'>
                            <Icon name='delete' color='alert' button onClick={() => onDelete(index)} />
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};